import Vue from 'vue';
import Vuex from 'vuex';
import app from './modules/app';
import user from './modules/user';
import admin from './modules/admin';
import getters from './getters';
import enterprise from './modules/enterprise';
import order from './modules/order';
import myorder from './modules/myOrder';
import oauths from './modules/oauths';
import myBuyApps from './modules/myBuyApps';
import stores from './modules/stores';
import appClassification from './modules/appClassification';
import delivery from './modules/delivery';
import enteriseApp from './modules/enteriseApp';
import warningInfo from './modules/warningInfo';
import product from './modules/product';

Vue.use(Vuex);
const store = new Vuex.Store({
  modules: {
    app,
    user,
    admin,
    enterprise,
    order,
    myorder,
    oauths,
    myBuyApps,
    stores,
    appClassification,
    delivery,
    enteriseApp,
    warningInfo,
    product
  },
  getters
});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js